import {ThemeIdentifiers} from '../themes/themeMapper';

export function determineOpCo(opCoId: string) {
    switch(opCoId) {
        case ThemeIdentifiers.THE_GENERAL_THEME_ID:
            return 'general';
        case ThemeIdentifiers.AMFAM_THEME_ID:
            return 'amfam';
        case ThemeIdentifiers.CAH_THEME_ID:
            return 'cah';
        case ThemeIdentifiers.MSA_THEME_ID:
            return 'msa'
        default:
            return 'amfam';
    }
}

export function routeToHomePage(opCoId: string) {
    switch(opCoId) {
        case ThemeIdentifiers.THE_GENERAL_THEME_ID:
            window.location.href = 'https://www.thegeneral.com/';
            break;
        case ThemeIdentifiers.AMFAM_THEME_ID:
            window.location.href = 'https://www.amfam.com/';
            break;
        case ThemeIdentifiers.CAH_THEME_ID:
            window.location.href = 'https://www.connectbyamfam.com/';
            break;
        case ThemeIdentifiers.MSA_THEME_ID:
            window.location.href = 'https://msainsurance.com/';
            break;
        default:
            window.location.href = 'https://www.amfam.com/';
            break;
    }
}

export function routeToMyAccount(opCoId: string) {
    switch(opCoId) {
        case ThemeIdentifiers.THE_GENERAL_THEME_ID:
            window.location.href = 'https://www.thegeneral.com/mypolicy/welcome.htm';
            break;
        case ThemeIdentifiers.AMFAM_THEME_ID:
            window.location.href = 'https://myaccount.amfam.com/login';
            break;
        case ThemeIdentifiers.CAH_THEME_ID:
            window.location.href = 'https://quickservice.connectbyamfam.com/NC';
            break;
        case ThemeIdentifiers.MSA_THEME_ID:
            window.location.href = 'https://myaccount.msainsurance.com/';
            break;
        default:
            window.location.href = 'https://www.amfam.com/';
            break;
    }
}

export const trustedOrigins = ['https://fnol-intake-int.amfam.com', 'https://fnol-intake-dev.amfam.com', 'https://fnol-intake.amfam.com','https://localhost.amfam.com:4200']